import { tour } from '../../walkthroughs/service'

export const services = {
    state: {
        status: 'idle',
        serviceStatus: 'idle',
        services: [],
        service: {},
        serviceShops: [],
        servicesWithCustomAction: {
            // serviceCode:{link:String}
            sgnk: {
                link: process.env.VUE_APP_CASH_AMOUNT_SERVICE_URL
            }
        },
        walkthroughServiceCode: null
    },
    mutations: {
        SET_SERVICES_STATUS(state, payload) {
            state.status = payload
        },
        SET_SERVICE_STATUS(state, payload) {
            state.serviceStatus = payload
        },
        SET_SERVICES(state, payload) {
            state.services = payload
        },
        SET_SERVICE(state, payload) {
            state.service = payload
        },
        SET_SERVICESHOPS(state, payload) {
            state.serviceShops = payload
        },
        SET_WALKTHROUGH_SERVICE_CODE(state, payload) {
            state.walkthroughServiceCode = payload
        }
    },
    actions: {
        servicesFetch({ state, commit, getters }, payload) {
            commit('SET_SERVICES_STATUS', 'loading')
            const userId = getters.userId
            const requestUrl = `subscriptions_services/${userId}/services/`
            return this.$api
                .get(requestUrl)
                .then(response => {
                    const services = response.data.data.services
                    commit('SET_SERVICES', services)
                    commit('SET_SERVICES_STATUS', 'idle')
                })
                .catch(err => {
                    if (!this.$api.isCancel(err)) {
                        commit('SET_SERVICES_STATUS', 'idle')
                    }
                })
        },
        serviceFetch({ state, commit, dispatch, getters }, payload) {
            if (state.status === 'idle') {
                commit('SET_SERVICE_STATUS', 'loading')
                const userId = getters.userId
                this.$api
                    .get(
                        `subscriptions_services/${userId}/services/${payload}`,
                        {
                            params: {
                                subscriptionsWithEntityData: true
                            }
                        }
                    )
                    .then(response => {
                        const setSubscriptionsData = response.data.data
                        setSubscriptionsData.subscriptions = setSubscriptionsData.subscriptions.map(
                            el => {
                                return {
                                    ...el,
                                    checked: el.status === 'active'
                                }
                            }
                        )
                        commit('SET_SERVICE', setSubscriptionsData)
                        if (setSubscriptionsData.subscriptions) {
                            dispatch(
                                'selectServiceShops',
                                setSubscriptionsData.subscriptions
                            )
                        }
                    })
                    .catch(err => {
                        console.log(err)
                    })
                    .finally(() => {
                        commit('SET_SERVICE_STATUS', 'idle')
                    })
            }
        },
        selectServiceShops({ commit }, payload) {
            commit('SET_SERVICESHOPS', payload)
        },
        setService({ commit }, payload) {
            commit('SET_SERVICE', payload)
        },
        selectServiceShop({ state, commit }, payload) {
            const serviceShops = state.serviceShops
            const selectedShop = serviceShops.find(
                el => el.entityData.id === payload.entityData.id
            )
            if (selectedShop.status === 'inactive') {
                selectedShop.checked = !selectedShop.checked
            }
            commit('SET_SERVICESHOPS', serviceShops)
        },
        async sendServiceActivateRequest({ getters }, payload) {
            const userId = getters.userId
            let params
            if (payload.level === 'User' || payload.level === 'Company') {
                params = {
                    activation_level: payload.level.toUpperCase(),
                    objectIds: [userId]
                }
            } else {
                params = {
                    activation_level: payload.level.toUpperCase(),
                    objectIds: payload.shopIds
                }
            }

            return await this.$api.patch(
                `subscriptions_services_on_off/users/${userId}/services/${payload.serviceId}/activate`,
                params
            )
        },
        async serviceActivate({ dispatch }, payload) {
            const res = await dispatch('sendServiceActivateRequest', payload)
            dispatch('toggleModal', false)
            if (res.status === 200) {
                if (payload.singleService) {
                    dispatch('serviceFetch', payload.serviceId)
                } else {
                    dispatch('servicesFetch')
                }
                await dispatch('setWalkthroughServiceCode', payload.serviceCode)
                tour.start()
                return dispatch('addNotification', {
                    type: 'success',
                    content: payload.allShops
                        ? 'Pomyślnie włączono usługę. Dostęp do usługi / promocji zostanie udzielony w przeciągu kilku minut.'
                        : 'Usługa została aktywowana w wybranych sklepach'
                })
            } else {
                return dispatch('addNotification', {
                    type: 'danger',
                    content:
                        'Nie udało się aktywować usługi we wskazanych sklepach. Skontaktuj się z naszym Helpdeskiem pod numerem 22 12 91 400'
                })
            }
        },
        serviceDeactivate({ getters, dispatch }, payload) {
            const userId = getters.userId
            let params
            if (payload.level === 'User' || payload.level === 'Company') {
                params = {
                    activation_level: payload.level.toUpperCase(),
                    objectIds: [userId]
                }
            } else {
                params = {
                    activation_level: payload.level.toUpperCase(),
                    objectIds: payload.shopIds
                }
            }
            this.$api
                .patch(
                    `subscriptions_services_on_off/users/${userId}/services/${payload.serviceId}/deactivate`,
                    params
                )
                .then(res => {
                    dispatch('toggleModal', false)
                    if (res.status === 200) {
                        if (payload.singleService) {
                            dispatch('serviceFetch', payload.serviceId)
                        } else {
                            dispatch('servicesFetch')
                        }
                        if (res.data.data.errors.length > 0) {
                            dispatch('addNotification', {
                                type: 'danger',
                                content: res.data.data.errors[0].message
                            })
                        } else {
                            dispatch('addNotification', {
                                type: 'success',
                                content: 'Usługa została wyłączona'
                            })
                        }
                    } else {
                        dispatch('addNotification', {
                            type: 'danger',
                            content: 'Wystąpił błąd'
                        })
                    }
                })
                .catch(err => console.log(err))
        },
        setWalkthroughServiceCode({ commit }, payload) {
            commit('SET_WALKTHROUGH_SERVICE_CODE', payload)
        }
    },
    getters: {
        getServicesWithCustomAction: state => {
            return state.servicesWithCustomAction
        },
        getServices: state => {
            if (state.services) {
                return state.services
            }
        },
        getServicesByStatus: state => status => {
            if (state.services) {
                if (status === 'active') {
                    return state.services.filter(
                        el => el.number_of_entities_with_subscription > 0
                    )
                } else if (status === 'available') {
                    return state.services.filter(
                        el =>
                            el.number_of_entities_with_subscription <
                            el.number_of_total_user_entities
                    )
                }
            }
        },
        getServicesStatus: state => {
            return state.status
        },
        getServiceStatus: state => {
            return state.serviceStatus
        },
        getService: state => {
            return state.service
        },
        getToActiveServiceShopIds: state => {
            return state.serviceShops
                .filter(el => el.status === 'inactive' && el.checked)
                .map(el => el.entityData.id)
        },
        getAllServiceShopIds: state => {
            return state.serviceShops
                .filter(el => el.status !== 'not_allowed')
                .map(el => el.entityData && el.entityData.id)
        },
        getServiceById: state => id => {
            return state.services.find(el => el.id === id)
        },
        getServiceByCode: state => code => {
            return state.services.find(el => el.code === code)
        },
        getWalkthroughServiceCode: state => {
            return state.walkthroughServiceCode
        },
        isServiceActive: (_, getters) => code => {
            const shopTagService = getters.getServiceByCode(code)
            return (
                shopTagService &&
                shopTagService.number_of_entities_with_subscription > 0
            )
        }
    }
}
